module.exports = __webpack_public_path__ + "static/media/landing-mobile-2x.feab3c20.jpg";